// extracted by mini-css-extract-plugin
export default {"pricingList":"p4WUyZT8MgVLPAgfIH3l","pricingItem":"GQJDaIfUGmld2FDXIZQP"};